import { GenericPad, KeyboardEventTypes, Vector3, Xbox360Button, Xbox360Pad } from '@babylonjs/core';
import { Button } from '@babylonjs/gui';
import { Game } from './Game';
import { GameState } from './GameState';
import { Gui } from './gui/Gui';

export class GameOver {
  constructor(public game: Game) {}

  async create() {
    await Gui.createDefaultScene(
      this.game,
      {
        url: 'assets/skybox/space.png',
        rotationAxis: 'y',
      },
      'Game Over'
    );
    await Gui.createAnimatedPlayer(this.game, 'WarriorIdle', new Vector3(0, -1, 0));
    await Gui.createBackButton(this.game, GameState.MAIN, '🎬');

    if (this.game.user.hasContinues()) {
      await this.createContinueButton();
    }

    await this.createRestartButton();

    await this.game.sound.createBackgroundMusic('SaladeDeSaison');
    this.setupInput();
  }

  private setupInput() {
    // Keyboard Input
    this.game.removeableObservers.push(
      this.game.scene.onKeyboardObservable.add((kbInfo) => {
        if (kbInfo.type === KeyboardEventTypes.KEYUP) {
          if (kbInfo.event.code === 'Space') {
            this.useContinue();
          }
          if (kbInfo.event.code === 'Escape') {
            this.restartGame();
          }
        }
      })
    );

    this.game.setupGamepad((gamepad) => {
      if (gamepad instanceof Xbox360Pad) {
        this.game.removeableObservers.push(
          gamepad.onButtonDownObservable.add((button) => {
            if (button === Xbox360Button.A) {
              this.useContinue();
            }
            if (button === Xbox360Button.B) {
              this.restartGame();
            }
          })
        );
      } else if (gamepad instanceof GenericPad) {
        this.game.removeableObservers.push(
          gamepad.onButtonDownObservable.add((button) => {
            if (button === 0) {
              this.useContinue();
            }
            if (button === 1) {
              this.restartGame();
            }
          })
        );
      }
    });
  }

  useContinue() {
    this.game.sound.play('click');
    this.game.user.useContinue();
    this.game.user.save();
    this.game.routeTo(GameState.LEVEL);
  }

  restartGame() {
    this.game.sound.play('click');
    this.game.user.reset();
    this.game.user.save();
    this.game.routeTo(GameState.SELECTION);
  }

  async createContinueButton(): Promise<Button> {
    const button = this.game.gui2D.createButton(
      'button_continue',
      '🎮 Continue',
      () => {
        this.useContinue();
      },
      this.game.gui2D.ui.rootContainer,
      1,
      this.game.gui2D.sceneButtonColors()
    );
    this.game.gui2D.styleSceneButton(button);
    button.top = '25%';
    return button;
  }

  async createRestartButton(): Promise<Button> {
    const button = this.game.gui2D.createButton(
      'button_restart',
      '🖥️ Restart',
      () => {
        this.restartGame();
      },
      this.game.gui2D.ui.rootContainer,
      1,
      this.game.gui2D.sceneButtonColors()
    );
    this.game.gui2D.styleSceneButton(button);
    button.top = '35%';
    return button;
  }
}
